import { APP_ROUTES } from '@/routes';

export const FOOTER_CONFIG = [
	{
		heading: 'Customer Service',
		links:   [
			{
				label:    'Shipping Policy',
				href:     APP_ROUTES.LEGAL.SHIPPING_POLICY,
				isNewTab: false,
			},
			{
				label:    'Track order',
				href:     'https://track.thailandpost.co.th',
				isNewTab: true,
			},
		],
	},
	{
		heading: 'Social Media',
		links:   [
			{
				label:    'Facebook',
				href:     'https://www.facebook.com/wasticofficial/?locale=th_TH',
				isNewTab: true,
			},
			{
				label:    'Instagram',
				href:     'https://www.instagram.com/wastic_official',
				isNewTab: true,
			},
			{
				label:    'Tiktok',
				href:     'https://www.tiktok.com/@wasticofficial',
				isNewTab: true,
			},
		],
	},
	{
		heading: 'Online Stores',
		links:   [
			{
				label:    'Lazada',
				href:     'https://s.lazada.co.th/l.2XlB',
				isNewTab: true,
			},
			{
				label:    'Shopee',
				href:     'https://shopee.co.th/wasticofficial',
				isNewTab: true,
			},
			{
				label:    'Tiktok',
				href:     'https://www.tiktok.com/@wasticofficial',
				isNewTab: true,
			},
		],
	},
	{
		heading: 'Customer Care',
		links:   [
			{
				label:    'FAQ',
				href:     APP_ROUTES.CUSTOMER_CARE.FAQ,
				isNewTab: false,
			},
			{
				label:    'Line @ wastic',
				href:     'https://line.me/R/ti/p/@Wastic',
				isNewTab: true,
			},
			{
				label:    'Email: wasticthailand@gmail.com',
				href:     'mailto:wasticthailand@gmail.com',
				isNewTab: true,
			},
		],
	},
	{
		heading: 'Legal',
		links:   [
			{
				label:    'Privacy Policy',
				href:     APP_ROUTES.LEGAL.PRIVACY_POLICY,
				isNewTab: false,
			},
			{
				label:    'Terms of Service',
				href:     APP_ROUTES.LEGAL.TERMS_OF_SERVICE,
				isNewTab: false,
			},
		],
	},
];